// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nextpax-airbnb-vrbo-grid[data-v-e5b4c400] .ag-cell-value{font-size:13px}", ""]);
// Exports
module.exports = exports;
